import React from 'react';
import PropTypes from 'prop-types';
import { Notification, Spacer, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const ProfileInfo = ({ error }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS:{
      USER_AUTHENTICATION:{
        labels:{
          REGISTRATION_INFO_HEADING,
          REGISTRATION_INFO_FILL_DETAIL
        },
        ERRORS_MESSAGES: {
          GENERIC_ERROR_HEADING
        }
      }
    }
  } = localizedStrings;

  return (
    <>
      <div id="main-content-title">
        <Typography heading="h2" variant={{ size: 'h2' }} block>
          {REGISTRATION_INFO_HEADING}
        </Typography>
      </div>
      <div id="main-content-steps">
        <Typography block>{REGISTRATION_INFO_FILL_DETAIL}</Typography>
      </div>

      {error ? (
        <>
          <Spacer space={2} />
          <Notification variant={{ validation: 'error' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'left'
              }}
            >
              <Typography variant={{ bold: true }}>
                {GENERIC_ERROR_HEADING}
              </Typography>
              <Typography>{error}</Typography>
            </div>
          </Notification>
          <Spacer space={2} />
        </>
      ) : null}
    </>
  );
};

ProfileInfo.propTypes = {
  error: PropTypes.bool.isRequired
};

export default ProfileInfo;
